import Guest from '@/layouts/guest';
import React from 'react';
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";
import styles from './error-404.module.scss';

const Error404: React.FC = () => {
  return (
    <Guest title="یافت نشد!">
      <Container className="py-5 text-center ltr">
        <div className="row">
            <div className="col-lg-4 col-md-6 p-0 d-flex mb-4">
                <img className="w-100 align-self-center" src="/images/samples/404.png" alt="صفحه موردنظر پیدا نشد. خطای ۴۰۴" />
            </div>
            <div className="col-lg-4 col-md-6 mb-4 rtl">
                <div className={styles.error404}>
                    <h2>404</h2>
                    <h4>صفحه موردنظر یافت نشد!</h4>
                    <p>با عرض پوزش، صفحه ای که روی آن کلیک کردید وجود ندارد</p>
                    <p>لطفا از لینک های مفید جهت یافتن صفحه موردنظر استفاده نمایید</p>
                </div>
            </div>
            <div className="col-lg-4 col-md-12 rtl">
                <div className={styles.links}>
                    <div className={styles.header}>
                        <h4>
                            <i className="fa fa-link" />
                            لینک های مفید
                        </h4>
                    </div>
                    <div className={styles.body}>
                        <ul>
                            <li><Link to={'/'}>صفحه اصلی</Link></li>
                            <li><Link to={'/beats'}>بیت‌ها</Link></li>
                            <li><Link to={'/texts'}>تکست‌ها</Link></li>
                            <li><Link to={'/maquettes'}>ماکت‌ها</Link></li>
                            <li><Link to={'/studios'}>استودیوها</Link></li>
                            <li><Link to={'/artists'}>آرتیست‌ها</Link></li>
                            <li><Link to={'/contact'}>تماس با ما</Link></li>
                            <li><Link to={'/terms'}>قوانین تکست نویس</Link></li>
                            <li><Link to={'/faq'}>سوالات متداول</Link></li>
                            <li><Link to={'/about'}>درباره ما</Link></li>
                            <li><Link to={'/register'}>عضویت</Link></li>
                            <li><Link to={'/login'}>ورود</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
      </Container>
    </Guest>
  );
}

export default Error404;
